import axios from "axios";
import appConfig from "../app-config";
const baseurl = appConfig.development.apiBaseUrl

export const ForgotPasswordAPI = {
    getForgotOTP: (bodyData) =>
        axios.post(`${baseurl}accounts-api/forgot-psd-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    postVerifyOTP: (bodyData) =>
        axios.post(`${baseurl}accounts-api/check-otp-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    postChangePswd: (bodyData) =>
        axios.post(`${baseurl}accounts-api/reset-password-with-otp-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
}